import { render, staticRenderFns } from "./MwcComponent.vue?vue&type=template&id=341a744c&scoped=true&"
import script from "./MwcComponent.vue?vue&type=script&lang=js&"
export * from "./MwcComponent.vue?vue&type=script&lang=js&"
import style0 from "./MwcComponent.vue?vue&type=style&index=0&id=341a744c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341a744c",
  null
  
)

export default component.exports